// import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Verband from './pages/Verband/Verband';
import Mitglieder from './pages/Mitglieder/Mitglieder';
import Navbar from './components/Navbar/Navbar';
import Kontakt from './components/Kontakt/Kontakt';
import Satzung from './pages/Satzung/Satzung';
import Impressum from './pages/Impressum/Impressum';
import Tarife from './pages/Tarife/Tarife';

function App() {
  return (
    <>
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Verband></Verband>}></Route>
        <Route path="/mitglieder" element={<Mitglieder></Mitglieder>}></Route>
        <Route path="/satzung" element={<Satzung></Satzung>}></Route>
        {/* Vertragsgestaltung vorerst rausgenommen (auch in Navbar)*/}
        {/* <Route path="/tarife" element={<Tarife></Tarife>}></Route>  */}
        <Route path="/impressum" element={<Impressum></Impressum>}></Route>
      </Routes>
      <Kontakt></Kontakt>
    </>
  );
}

export default App;
